(() => {
  /* PPA-R27b (2026-08-08): continuous logo reel, hardened.
     POP. cycles through all eleven treatments forever at a steady cadence.

     Why this shape: the theme's page-speed engine rewrites chunks of the DOM
     after load, replacing the header logo nodes. Any animation that holds
     element references goes on animating detached nodes while the visible
     clones sit frozen (that was the "stuck on charcoal" bug). So every tick
     re-queries the live DOM, re-asserts the playing state, and derives the
     frame purely from elapsed time — clone swaps, timer throttling, and
     duplicate script executions all become harmless. */

  const TICK_MS = 700;

  const shouldStayStatic = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    (navigator.connection && navigator.connection.saveData);

  function tick(t0) {
    if (document.visibilityState === 'hidden') return;
    document.querySelectorAll('[data-ppa-logo-reel]').forEach(root => {
      const frames = root.querySelectorAll('[data-ppa-frame]');
      if (frames.length < 11) return;
      const idx = Math.floor((performance.now() - t0) / TICK_MS) % frames.length;
      root.classList.add('is-playing');
      frames.forEach((frame, i) => {
        frame.style.opacity = i === idx ? '1' : '0';
        frame.classList.toggle('is-current', i === idx);
        frame.style.transform = 'none';
      });
    });
  }

  /* PPA-R30: iOS Safari suspends timers in a backgrounded tab and does not
     always resume them — returning to the tab (or a bfcache restore via the
     back button) left a dead interval, so the reel froze on whatever frame was
     up. Restarting on visibilitychange/pageshow revives it; the frame stays
     time-derived, so it resumes at the right point rather than jumping. */
  let timer = null;
  let t0 = 0;

  function start() {
    if (timer) clearInterval(timer);
    tick(t0);
    timer = setInterval(() => tick(t0), TICK_MS);
  }

  function init() {
    if (shouldStayStatic()) return;           /* static official logo */
    const root = document.querySelector('[data-ppa-logo-reel]');
    if (!root) return;
    const images = [...root.querySelectorAll('[data-ppa-frame]')];
    Promise.race([
      Promise.all(images.map(img => img.decode ? img.decode().catch(() => {}) : Promise.resolve())),
      new Promise(resolve => setTimeout(resolve, 4000))
    ]).then(() => {
      t0 = performance.now();
      start();
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') start();
      });
      window.addEventListener('pageshow', start);
    });
  }

  if (!window.__ppaReelInitDone) {
    window.__ppaReelInitDone = true;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  }

  window.PremierPopArtLogo = { tick };
})();
